import { render, staticRenderFns } from "./JsonEditorDummy.vue?vue&type=template&id=f44ea9c0&"
import script from "./JsonEditorDummy.vue?vue&type=script&lang=js&"
export * from "./JsonEditorDummy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports